<script setup lang="ts">
const { t } = useI18n()
// 5 hero screens matching the real Flutter app, in narrative order:
//   route picker → catalog → virtual card → echo received → bank balance
// = start journey → browse → pay at till → handover signature → courier earns.
</script>

<template>
  <section class="rod-section relative overflow-hidden">
    <div class="rod-aurora" style="opacity: 0.35;" />
    <div class="rod-container relative">
      <div class="text-center max-w-3xl mx-auto mb-14" data-reveal>
        <div class="rod-eyebrow mb-5">📲 {{ t('screens.eyebrow') }}</div>
        <h2 class="rod-h2 mb-5">{{ t('screens.title') }}</h2>
        <p class="text-lg text-[var(--color-text-muted)]">{{ t('screens.lead') }}</p>
      </div>

      <!-- Desktop: 3 + 2 layout -->
      <div class="hidden lg:flex justify-center items-end gap-6 mb-12" data-reveal>
        <div class="flex flex-col items-center gap-3">
          <PhoneFrame tilt="left" :delay="0"><AppScreensRoutePicker /></PhoneFrame>
          <div class="text-center">
            <div class="font-display font-semibold">{{ t('screens.routePicker.title') }}</div>
            <div class="text-xs text-[var(--color-text-dim)]">{{ t('screens.routePicker.subtitle') }}</div>
          </div>
        </div>
        <div class="flex flex-col items-center gap-3 -translate-y-8">
          <PhoneFrame tilt="center" :delay="-800"><AppScreensCatalog /></PhoneFrame>
          <div class="text-center">
            <div class="font-display font-semibold">{{ t('screens.catalog.title') }}</div>
            <div class="text-xs text-[var(--color-text-dim)]">{{ t('screens.catalog.subtitle') }}</div>
          </div>
        </div>
        <div class="flex flex-col items-center gap-3">
          <PhoneFrame tilt="right" :delay="-1600"><AppScreensVirtualCard /></PhoneFrame>
          <div class="text-center">
            <div class="font-display font-semibold">{{ t('screens.vcard.title') }}</div>
            <div class="text-xs text-[var(--color-text-dim)]">{{ t('screens.vcard.subtitle') }}</div>
          </div>
        </div>
      </div>

      <div class="hidden lg:flex justify-center items-end gap-10" data-reveal>
        <div class="flex flex-col items-center gap-3">
          <PhoneFrame tilt="left" :delay="-2400"><AppScreensEchoReceived /></PhoneFrame>
          <div class="text-center">
            <div class="font-display font-semibold">{{ t('screens.echo.title') }}</div>
            <div class="text-xs text-[var(--color-text-dim)]">{{ t('screens.echo.subtitle') }}</div>
          </div>
        </div>
        <div class="flex flex-col items-center gap-3">
          <PhoneFrame tilt="right" :delay="-3200"><AppScreensBankBalance /></PhoneFrame>
          <div class="text-center">
            <div class="font-display font-semibold">{{ t('screens.bank.title') }}</div>
            <div class="text-xs text-[var(--color-text-dim)]">{{ t('screens.bank.subtitle') }}</div>
          </div>
        </div>
      </div>

      <!-- Mobile: horizontal scroll -->
      <div class="lg:hidden -mx-6 px-6 overflow-x-auto" data-reveal>
        <div class="flex gap-6 pb-4">
          <div class="flex flex-col items-center gap-3 flex-shrink-0">
            <PhoneFrame tilt="none" :floaty="false"><AppScreensRoutePicker /></PhoneFrame>
            <div class="text-center text-xs"><div class="font-display font-semibold">{{ t('screens.routePicker.title') }}</div></div>
          </div>
          <div class="flex flex-col items-center gap-3 flex-shrink-0">
            <PhoneFrame tilt="none" :floaty="false"><AppScreensCatalog /></PhoneFrame>
            <div class="text-center text-xs"><div class="font-display font-semibold">{{ t('screens.catalog.title') }}</div></div>
          </div>
          <div class="flex flex-col items-center gap-3 flex-shrink-0">
            <PhoneFrame tilt="none" :floaty="false"><AppScreensVirtualCard /></PhoneFrame>
            <div class="text-center text-xs"><div class="font-display font-semibold">{{ t('screens.vcard.title') }}</div></div>
          </div>
          <div class="flex flex-col items-center gap-3 flex-shrink-0">
            <PhoneFrame tilt="none" :floaty="false"><AppScreensEchoReceived /></PhoneFrame>
            <div class="text-center text-xs"><div class="font-display font-semibold">{{ t('screens.echo.title') }}</div></div>
          </div>
          <div class="flex flex-col items-center gap-3 flex-shrink-0">
            <PhoneFrame tilt="none" :floaty="false"><AppScreensBankBalance /></PhoneFrame>
            <div class="text-center text-xs"><div class="font-display font-semibold">{{ t('screens.bank.title') }}</div></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
